
















































import { Component, Vue, Prop, PropSync } from 'vue-property-decorator'
import { GradeFrameController } from '@/services/request.service'

@Component
export default class FeatureEditor extends Vue {
  @Prop({ default: false }) private canSelectFrame!: boolean
  @Prop({ default: () => [] }) private usedFrames!: any
  @PropSync('frame', {
    type: Object,
    default: () => ({
      frameIds: [],
    }),
  })
  private frameEditor!: any

  private assessmentFrames: Array<any> = []

  private get rules(): any {
    return {
      frameIds: [
        {
          required: true,
          message: this.$tc('distributorMgmt.selectFrame'),
          trigger: 'change',
        },
      ],
    }
  }

  private created(): void {
    this.getAssessmentFrame()
  }

  private getAssessmentFrame(): void {
    GradeFrameController.getGradeFrameList()
      .then(res => {
        this.assessmentFrames = res.data.gradeFrameList
      })
      .catch(err => {
        console.error(err)
      })
  }
}
